module.exports = __webpack_public_path__ + "static/media/land-scanner-banner-img.5ef120f3.jpg";